import { render } from "./UpdateModal.vue?vue&type=template&id=759dc1a8&scoped=true"
import script from "./UpdateModal.vue?vue&type=script&lang=js"
export * from "./UpdateModal.vue?vue&type=script&lang=js"

import "./UpdateModal.vue?vue&type=style&index=0&id=759dc1a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759dc1a8"]])

export default __exports__